/**
 * Performance Chart Skeleton Component
 *
 * Loading skeleton for the PerformanceChart.
 */

import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

interface PerformanceChartSkeletonProps {
  className?: string;
}

/**
 * Skeleton loader for PerformanceChart
 */
export function PerformanceChartSkeleton({
  className,
}: PerformanceChartSkeletonProps) {
  return (
    <Card className={cn(className)}>
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <Skeleton className="h-5 w-28" />
          <Skeleton className="h-8 w-32 rounded-lg" />
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {/* Summary stats skeleton */}
          <div className="flex justify-between items-center">
            <div className="space-y-1">
              <Skeleton className="h-3 w-12" />
              <Skeleton className="h-5 w-16" />
            </div>
            <div className="space-y-1 text-center">
              <Skeleton className="h-3 w-12 mx-auto" />
              <Skeleton className="h-5 w-24" />
            </div>
            <div className="space-y-1">
              <Skeleton className="h-3 w-12 ml-auto" />
              <Skeleton className="h-5 w-16 ml-auto" />
            </div>
          </div>

          {/* Chart area skeleton */}
          <Skeleton className="w-full h-52 rounded-lg" />

          {/* Legend skeleton */}
          <div className="flex justify-center gap-6">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="flex items-center gap-2">
                <Skeleton className="h-0.5 w-4" />
                <Skeleton className="h-3 w-16" />
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
